import UserProfile from './Profile'

export default UserProfile
